import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/commons/Icon';

import { Wrapper, Button } from './styles';

const CurrencyReverseButton = memo(({ title, onReverse }) => (
  <Wrapper>
    <Button type="button" onClick={onReverse} title={title}>
      <Icon name="dualArrows" />
    </Button>
  </Wrapper>
));

CurrencyReverseButton.propTypes = {
  title: PropTypes.string.isRequired,
  onReverse: PropTypes.func.isRequired,
};

export default CurrencyReverseButton;
